// Use "globalThis" instead of "window", "self", or "global" (javascript:S7764)
const window = globalThis.window;

/**
 * Validates a fetch Response: resolves with the Response when OK, reloads the
 * page on a strict 401, or throws a normalized error built from the response
 * body.
 *
 * @param {Response} response - The fetch Response to validate.
 * @param {boolean} [reloadOn401=true] - When true, a 401 status triggers a
 *     page reload and the promise resolves to `false` instead of throwing.
 * @returns {Promise<Response>} The original Response
 * @throws {{status: number, statusText: string, userMessage: (string|undefined)}}
 *     When the response is not OK (and not a strict 401), populated from the
 *     parsed JSON error body.
 */
export default async function fetchCheck(response, reloadOn401 = true) {
  if (response.ok) {
    return response;
  }

  /**
   * The HTTP 401 Unauthorized client error response status code indicates that a request was not successful because it lacks valid authentication credentials for the requested resource. This status code is sent with an HTTP WWW-Authenticate response header that contains information on the authentication scheme the server expects the client to include to make the request successfully.
   */
  if (reloadOn401 && response.status === 401) {
    if (window) {
      window.location.reload(true);
    }

    return response;
  }

  const errorDtls = await response.json();
  const err = {
    status: response.status,
    statusText: response.statusText,
    userMessage: errorDtls && errorDtls.message,
  };

  throw err;
}
